<template>
    <div id="create-event-modal">
        <a-modal id="event-modal" :visible="true" :cancelText="$t('calendar.cancel')" :okText="$t('message.save')" centered @cancel="$emit('close')"
                 :footer="null">
            <div class="modal-container">
                <ReservationEventModal
                    v-if="!!eventDetail.reservationId"
                    :eventDetail="eventDetail"
                    @deleteEvent="onDeleted"
                    @close="$emit('close')"
                />
                <CreateEventForm
                    :eventSummary="eventSummary"
                    :eventDetail="eventDetail"
                    :selectedStartDate="selectedStartDate"
                    :selectedEndDate="selectedEndDate"
                    :calendarList="calendarList"
                    :refVisitor="refVisitor"
                    @close="$emit('close')"
                    @deleteEvent="onDeleted"
                    @editEvent="$emit('editEvent', $event)"
                    :footerVisible="footerVisible"
                    v-else
                />
            </div>
        </a-modal>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { log2 } from "../../../../utils/log2";
import moment from "moment";
import CreateEventForm from "./CreateEventForm.vue";
import ReservationEventModal from "./ReservationEventModal.vue";
import { PERMISSION_TYPES } from "../../../../language/permissionTypes";

moment.locale("tr");
const log = log2("CreateEventModal");
export default {
    name: "CreateEventModal",
    components: { CreateEventForm, ReservationEventModal },
    props: {
        footerVisible: {
            type: Boolean,
            default: true,
        },
        refVisitor: {
            type: String,
            default: "",
        },
        eventSummary: {
            type: String,
            default: "",
        },
        eventDetail: {
            type: Object,
            default: () => ({}),
        },
        selectedStartDate: {
            type: Date,
            default: () => new Date(),
        },
        selectedEndDate: {
            type: Date,
            default: () => moment().add(1, "hour").toDate(),
        },
        calendarList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({}),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    methods: {
        onClosed() {
            this.$emit("close");
        },
        onDeleted(payload) {
            this.$emit("deleteEvent", payload);
        },
    },
    async mounted() {
        console.log("CreateEventModal eventDetail", this.eventDetail);
    },
    watch: {},
    beforeCreate() {
        if (this.checkPermission && !this.checkPermission(PERMISSION_TYPES["calendar.create"].tr.name)) {
            this.$message.error(this.$t("permissionErrors.calendarUpdate"));
            this.$emit("close");
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-container {
    width: 95%;
}

#create-event-modal {
    background-color: #ffffff;
    height: 100%;
}
</style>
<style lang="scss">
#event-modal {
    .ant-modal-mask {
        z-index: 99999 !important;
    }

    .ant-modal-wrap {
        z-index: 99999 !important;
    }
}
</style>
